import React, { Component } from "react";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";

// Scrolling Component
import { ScrollToTop } from "./components/index.js";

// PAGES
import MainPage from "./pages/index.jsx";
import About from "./pages/about.jsx";
import projectspage from "./pages/projectspage.jsx";
import blog_page from "./pages/blogs/main_page.jsx";
import blog1 from "./pages/blogs/blog1.jsx";
import blog2 from "./pages/blogs/blog2.jsx";
import blog3 from "./pages/blogs/blog3.jsx"
import digitalForensicsHomelab from "./pages/labs/digital-forensics-homelab.jsx";
import digitalForensicsHomelabTopology from "./pages/labs/digital-forensics-homelab-topology.jsx";
import digitalForensicsHomelabActiveDirectory from "./pages/labs/digital-forensics-homelab-active-directory.jsx";
import digitalForensicsHomelabSysvol from "./pages/labs/digital-forensics-homelab-sysvol.jsx";
import digitalForensicsHomelabGpos from "./pages/labs/digital-forensics-homelab-gpos.jsx";
import digitalForensicsHomelabLogging from "./pages/labs/digital-forensics-homelab-logging.jsx";
import cases from "./pages/cases/cases.jsx";
import case001 from "./pages/cases/case-001-cracked-tool-beaconing.jsx";
import notfound from "./pages/404.jsx";
import Helmet from "react-helmet";

class App extends Component{
  render(){
    return(
      <Router>
        <ScrollToTop>
          <Switch>
            <Route exact path="/" component={MainPage} />
            <Route exact path="/about" component={About} />
            <Route exact path="/projects" component={projectspage} />
            <Redirect exact from="/certifications" to="/about#certifications" />
            <Route exact path="/blogs" component={blog_page} />
            <Route exact path="/how-i-ended-up-doing-computer-science" component={blog1} />
            <Route exact path="/my-entrepreneurial-journey" component={blog2} />
            <Route exact path="/2-factor-authentication" component={blog3} />
            <Route exact path="/digital-forensics-homelab" component={digitalForensicsHomelab} />
            <Route exact path="/digital-forensics-homelab-topology" component={digitalForensicsHomelabTopology} />
            <Route exact path="/digital-forensics-homelab-active-directory" component={digitalForensicsHomelabActiveDirectory} />
            <Route exact path="/digital-forensics-homelab-sysvol" component={digitalForensicsHomelabSysvol} />
            <Route exact path="/digital-forensics-homelab-gpos" component={digitalForensicsHomelabGpos} />
            <Route exact path="/digital-forensics-homelab-logging" component={digitalForensicsHomelabLogging} />
            <Route exact path="/cases" component={cases} />
            <Route exact path="/cases/case-001-cracked-tool-beaconing" component={case001} />
            <Route component={notfound}/>
            {/* <Redirect to="/404" /> */}
          </Switch>
        </ScrollToTop>
      </Router>
    );
  }
}

export default App;
